import { Interval } from '../../../../../Api/campaigns'
import IntervalInput from '../../IntervalInput'
import { NumberInput } from '../../../../../Components/Input/NumberInput'
import React from 'react'
import { Stack } from 'office-ui-fabric-react'

interface Props {
  disabled: boolean
  gap: number
  limit: number | null
  interval: Interval | null
  onChange: (limit: number | null, interval: Interval | null) => void
}

const EventsPerUserCappingFields: React.FC<Props> = ({
  disabled,
  gap,
  limit,
  interval,
  onChange,
}) => (
  <Stack horizontal>
    <NumberInput
      label="User limit"
      style={{ flexGrow: 1, maxWidth: `calc(50% - ${gap / 2}px)` }}
      errorMessage={undefined}
      name="eventsPerUser"
      value={limit}
      onChange={(value?: number) => {
        if (value == null) {
          return
        }
        onChange(value, interval)
      }}
      min={0}
      max={100}
      disabled={disabled}
      required={true}
    />
    <div style={{ width: gap }} />
    <IntervalInput
      disabled={disabled}
      interval={interval || { value: 0, unit: 'Hour' }}
      onChange={(interval) => onChange(limit, interval)}
    />
  </Stack>
)

export default EventsPerUserCappingFields
